import { render, staticRenderFns } from "./ReporteFlujoCaja.vue?vue&type=template&id=ef87de4a&scoped=true&"
import script from "./ReporteFlujoCaja.vue?vue&type=script&lang=js&"
export * from "./ReporteFlujoCaja.vue?vue&type=script&lang=js&"
import style0 from "./ReporteFlujoCaja.vue?vue&type=style&index=0&id=ef87de4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef87de4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VIcon,VProgressCircular,VSkeletonLoader})
